export const getSoftSize = (size: number) => {
  const kb = size / Math.pow(2, 10);
  const mb = size / Math.pow(2, 20);
  const gb = size / Math.pow(2, 30);
  if (mb < 1) {
    if (kb >= 100 && kb < 1000) {
      return `${kb.toString().slice(0, 3)}KB`;
    }
    return `${kb.toString().slice(0, 4)}KB`;
  }
  if (gb < 1) {
    if (mb >= 100 && mb < 1000) {
      return `${mb.toString().slice(0, 3)}MB`;
    }
    return `${mb.toString().slice(0, 4)}MB`;
  }
  if (gb >= 100 && gb < 1000) {
    return `${gb.toString().slice(0, 3)}GB`;
  }
  return `${gb.toString().slice(0, 4)}GB`;
};

export const urlToObject = () => {
  const _locationParam = window.location.search.substring(1);
  if (!_locationParam) {
    return {};
  }
  const _locationData = _locationParam.split("&");
  const result = _locationData.reduce((obj, item) => {
    const [key, val] = item.split("=");
    obj[key] = val;
    return obj;
  }, {} as any);
  return result;
};

export const greaterVersion = (
  currentVersion: string,
  targetVersion: string,
) => {
  if (!currentVersion) {
    return false;
  }
  const current = currentVersion.split(".");
  const target = targetVersion.split(".");

  for (let i = 0; i < current.length; i++) {
    if (+current[i] === +target[i]) {
      continue;
    }

    if (+current[i] > +target[i]) {
      return true;
    } else {
      return false;
    }
  }

  return false;
};

export const isMac = () => {
  return (
    navigator.platform === "Mac68K" ||
    navigator.platform === "MacPPC" ||
    navigator.platform === "Macintosh" ||
    navigator.platform === "MacIntel"
  );
};

export const isLinux = () => {
  return navigator.platform.indexOf("Linux") > -1;
};

export const isWin = () => {
  return navigator.platform === "Win32" || navigator.platform === "Windows";
};

export const isUnix = () => {
  return !(isWin() || isMac()) && navigator.platform === "X11";
};

export const getOSVersion = () => {
  const ua = window.navigator.userAgent;
  if (isWin()) {
    if (ua.indexOf("Windows NT 10") > -1) {
      return "Win10";
    }

    if (ua.indexOf("Windows NT 6.1") > -1 || ua.indexOf("Windows 7") > -1) {
      return "Win7";
    }

    if (ua.indexOf("Windows NT 5.0") > -1 || ua.indexOf("Windows 2000") > -1) {
      return "Win2000";
    }

    if (ua.indexOf("Windows NT 5.1") > -1 || ua.indexOf("Windows XP") > -1) {
      return "WinXP";
    }

    if (ua.indexOf("Windows NT 5.2") > -1 || ua.indexOf("Windows 2003") > -1) {
      return "Win2003";
    }

    if (ua.indexOf("Windows NT 6.0") > -1 || ua.indexOf("Windows Vista") > -1) {
      return "vista";
    }

    if (ua.indexOf("Windows NT 6.3") > -1 || ua.indexOf("Windows 8.1") > -1) {
      return "Win8.1";
    }

    if (ua.indexOf("Windows NT 6.2") > -1 || ua.indexOf("Windows 8") > -1) {
      return "Win8";
    }
  }

  if (isMac()) {
    return "Mac";
  }

  if (isLinux()) {
    return "Linux";
  }

  if (isUnix()) {
    return "Unix";
  }

  return "unknown";
};

export const getElementPosition = (
  element: HTMLElement,
  parentElement = document.body,
) => {
  let offsetLeft = 0;
  let offsetTop = 0;
  while (element && element !== parentElement) {
    offsetLeft += element.offsetLeft;
    offsetTop += element.offsetTop;
    element = element.offsetParent as HTMLElement;
  }
  return [offsetLeft, offsetTop];
};
